const dance = async (moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45) => {
    await moveMargin();
    await sleep(300);
    changeColor('green');
    paramsReference.direction = await rotateLeft45(paramsReference.direction);
    await sleep(300);
    paramsReference.direction = await rotateRight45(paramsReference.direction);
    changeColor('blue');
    await moveMargin();
    await sleep(300);
    changeColor('green');
    paramsReference.direction = await rotateRight45(paramsReference.direction);
    await sleep(300);
    paramsReference.direction = await rotateLeft45(paramsReference.direction);
    await sleep(300);
};

const iterateCounter = async (moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45) => {
    let counter = localStorage.getItem('counter') ? parseInt(localStorage.getItem('counter'), 10) : 0;
    counter += 1;
    if (counter === 5) {
        moveMargin();
        await dance(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        for (let i = 0; i <= 3; i++) {
            await changeColor('white')
                .then(() => changeColor('red'));
        }
        localStorage.setItem('is_ozobot_running', '0');
        localStorage.removeItem('counter_command');
        localStorage.removeItem('counter');
        return;
    }
    localStorage.setItem('counter', counter.toString());
};

const addIntersection = async (moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45) => {
    if (localStorage.getItem('counter_command') !== 'intersections') return;
    await iterateCounter(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
};

const addTurn = async (moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45) => {
    if (localStorage.getItem('counter_command') !== 'turns') return;
    await iterateCounter(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
};

const addColorPath = async (moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45) => {
    if (localStorage.getItem('counter_command') !== 'color_paths') return;
    await iterateCounter(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
};

export const RedPuzzle = async (currentPuzzle, changeColor, moveMargin, sleep, paramsReference, rotateLeft45, rotateRight45) => {
    if (['ah', 'aj', 'ag', 'ak', 'ai'].indexOf(currentPuzzle.id) > -1) {
        changeColor('red');
        if (localStorage.getItem('actual_color') !== 'red') {
            await addColorPath(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        }
        localStorage.setItem('actual_color', 'red');
    }
};

export const GreenPuzzle = async (currentPuzzle, changeColor, moveMargin, sleep, paramsReference, rotateLeft45, rotateRight45) => {
    if (['am', 'ao', 'al', 'ap', 'an'].indexOf(currentPuzzle.id) > -1) {
        changeColor('green');
        if (localStorage.getItem('actual_color') !== 'green') {
            await addColorPath(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        }
        localStorage.setItem('actual_color', 'green');
    }
};

export const BluePuzzle = async (currentPuzzle, changeColor, moveMargin, sleep, paramsReference, rotateLeft45, rotateRight45) => {
    if (['as', 'au', 'ar', 'aw', 'at'].indexOf(currentPuzzle.id) > -1) {
        changeColor('blue');
        if (localStorage.getItem('actual_color') !== 'blue') {
            await addColorPath(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        }
        localStorage.setItem('actual_color', 'blue');
    }
};

export const DefaultPuzzle = async (currentPuzzle, changeColor) => {
    if (['ac', 'ae', 'ab', 'af', 'ad', 'bw', 'bx', 'by', 'bz', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'cg', 'ch', 'ci', 'cj',
        'ck', 'cl', 'cm', 'cn', 'co', 'cp', 'cr', 'cs', 'ct', 'cu', 'cw', 'cx', 'cy', 'cz', 'da', 'db', 'dc', 'dd', 'de',
        'df', 'dg', 'dh', 'di', 'dj', 'dk', 'dl'].indexOf(currentPuzzle.id) > -1
    ) {
        changeColor('white');
    }
};

export const TurnCommand = async (currentPuzzle, paramsReference, rotateRight45, rotateLeft45, sleep) => {
    if (['ad', 'ai', 'an', 'at'].indexOf(currentPuzzle.id) > -1) {
        if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 's')
        ) {
            paramsReference.direction = await rotateRight45(paramsReference.direction);
            await sleep(80);
            paramsReference.direction = await rotateRight45(paramsReference.direction);
        } else if ((currentPuzzle.direction === 'e' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'w')
        ) {
            paramsReference.direction = await rotateLeft45(paramsReference.direction);
            await sleep(80);
            paramsReference.direction = await rotateLeft45(paramsReference.direction);
        }
    }
};

export const Crossroad4Command = async (currentPuzzle, paramsReference, forward, rotateLeft, rotateRight, moveMargin, sleep,
                                        changeColor, rotateLeft45, rotateRight45) => {
    if (['ae', 'aj', 'ao', 'au'].indexOf(currentPuzzle.id) > -1) {
        const storage = GetOzobotStorage();
        await addIntersection(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        if (storage.command) {
            await rotateByCommand(storage.command, paramsReference, forward, rotateLeft, rotateRight, moveMargin, sleep,
                changeColor, rotateLeft45, rotateRight45);
        } else {
            const moves = [forward, rotateLeft, rotateRight];
            const randomMove = moves[Math.floor(Math.random() * moves.length)];
            paramsReference.direction = await randomMove(paramsReference.direction);
            if (randomMove.name === 'rotateLeft' || randomMove.name === 'rotateRight')
                await addTurn(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        }
    }
};

export const Crossroad3Command = async (currentPuzzle, paramsReference, forward, rotateLeft, rotateRight, moveMargin, sleep,
                                        changeColor, rotateLeft45, rotateRight45) => {
    if (['af', 'ak', 'ap', 'aw'].indexOf(currentPuzzle.id)  > -1) {
        let moves = [];
        await addIntersection(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        const storage = GetOzobotStorage();
        if ((currentPuzzle.direction === 's' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 'e' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 'n')
        ) {
            if (storage.command) {
                await rotateByCommand(storage.command, paramsReference, forward, null, rotateRight, moveMargin,
                    sleep, changeColor, rotateLeft45, rotateRight45);
            } else {
                moves = [forward, rotateRight];
            }
        } else if ((currentPuzzle.direction === 's' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 'e' && paramsReference.direction === 'w')
        ) {
            if (storage.command) {
                await rotateByCommand(storage.command, paramsReference, forward, rotateLeft, null, moveMargin,
                    sleep, changeColor, rotateLeft45, rotateRight45);
            } else {
                moves = [forward, rotateLeft];
            }
        } else if ((currentPuzzle.direction === 's'  && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'e'  && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w'  && paramsReference.direction === 's')
            || (currentPuzzle.direction === 'n'  && paramsReference.direction === 'w')
        ) {
            if (storage.command) {
                await rotateByCommand(storage.command, paramsReference, null, rotateLeft, rotateRight, moveMargin,
                    sleep, changeColor, rotateLeft45, rotateRight45);
            } else {
                moves = [rotateLeft, rotateRight];
            }
        } else {
            moves = [forward];
        }

        if (moves.length > 0) {
            const randomMove = moves[Math.floor(Math.random() * moves.length)];
            paramsReference.direction = await randomMove(paramsReference.direction);
            if (randomMove.name === 'rotateLeft' || randomMove.name === 'rotateRight')
                await addTurn(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
        }
    }
};

const rotateRandom = async (paramsReference, changeColor, rotateLeft, rotateRight) => {
    const moves = [rotateLeft, rotateRight];
    paramsReference.direction = await moves[Math.floor(Math.random() * moves.length)](paramsReference.direction);
    changeColor('white');
};

export const TurboCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bc') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('blue')
                .then(() => changeColor('green'))
                .then(() => changeColor('blue'))
                .then(() => {
                    paramsReference.speed = 2;
                    return changeColor('white');
                })
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('white'));
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const SlowCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bd') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('white'))
                .then(() => changeColor('red'))
                .then(() => {
                    paramsReference.speed = 0.5;
                    return changeColor('white');
                })
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('white'));
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const PauseCommand = async (currentPuzzle, sleep, changeColor, paramsReference, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'be') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('blue'))
                .then(() => changeColor('red'))
                .then(() => changeColor('white'))
                .then(() => changeColor('white'))
                .then(() => changeColor('red'))
                .then(() => changeColor('white'))
                .then(() => changeColor('red'))
                .then(() => changeColor('white'))
                .then(() => changeColor('red'));

                await sleep(3000);
                changeColor('white');
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const UTurnCommand = async (currentPuzzle, paramsReference, rotateRight, rotateLeft, changeColor) => {
    if (currentPuzzle.id === 'bg') {
        if ((currentPuzzle.direction === 'n' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 'e' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'e')
        ) {
            changeColor('blue')
                .then(() => changeColor('white'))
                .then(() => changeColor('red'))
                .then(() => changeColor('white'))
                .then(() => changeColor('blue'))
                .then(() => changeColor('white'));

            paramsReference.direction = await rotateRight(paramsReference.direction);
            paramsReference.direction = await rotateRight(paramsReference.direction);
        } else if (currentPuzzle.direction === paramsReference.direction) {
            paramsReference.direction = await rotateRight(paramsReference.direction);
        } else if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'n')
        ) {
            paramsReference.direction = await rotateLeft(paramsReference.direction);
        }

        changeColor('white');
    }
};

export const StartCommand = async (currentPuzzle, paramsReference, rotateRight, rotateLeft, sleep) => {
    if (currentPuzzle.id === 'ax') {
        if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'e')
        ) {
            paramsReference.direction = await rotateRight(paramsReference.direction);
            await sleep(100);
            paramsReference.direction = await rotateRight(paramsReference.direction);
        } else if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 's')
        ) {
            paramsReference.direction = await rotateLeft(paramsReference.direction);
        }
        else if (currentPuzzle.direction === paramsReference.direction) {
            paramsReference.direction = await rotateRight(paramsReference.direction);
        }
    }
};

export const EndCommand = async (currentPuzzle, paramsReference, rotateRight45, rotateLeft45, sleep, changeColor, moveMargin) => {
    if (currentPuzzle.id === 'ay') {
        if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 'w')
        ) {
            await changeColor('green')
                .then(() => changeColor('red'))
                .then(() => changeColor('green'))
                .then(() => changeColor('blue'));

            await dance(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
            localStorage.setItem('is_ozobot_running', '0');
            for (let i = 0; i < 8; i++) {
                paramsReference.direction = await rotateLeft45(paramsReference.direction);
                await sleep(300);
            }

        } else if (currentPuzzle.direction === paramsReference.direction) {
            paramsReference.direction = await rotateRight45(paramsReference.direction);
            paramsReference.direction = await rotateRight45(paramsReference.direction);
            changeColor('white');
        } else if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'n')
        ) {
            paramsReference.direction = await rotateLeft45(paramsReference.direction);
            paramsReference.direction = await rotateLeft45(paramsReference.direction);
            changeColor('white');
        } else {
            changeColor('white');
        }
    }
};

export const CustomEndCommand = async (currentPuzzle, paramsReference, rotateRight, rotateLeft, sleep, changeColor) => {
    if (currentPuzzle.id === 'bs') {
        if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'n')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 'w')
        ) {
            localStorage.setItem('is_ozobot_running', '0');
        } else if (currentPuzzle.direction === paramsReference.direction) {
            paramsReference.direction = await rotateRight(paramsReference.direction);
            changeColor('white');
        } else if ((currentPuzzle.direction === 'e' && paramsReference.direction === 'w')
            || (currentPuzzle.direction === 'w' && paramsReference.direction === 'e')
            || (currentPuzzle.direction === 'n' && paramsReference.direction === 's')
            || (currentPuzzle.direction === 's' && paramsReference.direction === 'n')
        ) {
            paramsReference.direction = await rotateLeft(paramsReference.direction);
            changeColor('white');
        } else {
            changeColor('white');
        }
    }
};

export const EmptyPuzzleCommand = currentPuzzle => {
    if (['ab', 'ag', 'al', 'ar', 'bw', 'bx', 'by', 'bz', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'cg', 'ch', 'ci', 'cj', 'ck',
        'cl', 'cm', 'cn', 'co', 'cp', 'cr', 'cs', 'ct', 'cu', 'cw', 'cx', 'cy', 'cz', 'da', 'db', 'dc', 'dd', 'de', 'df',
        'dg', 'dh', 'di', 'dj', 'dk', 'dl'].indexOf(currentPuzzle.id) > -1
    ) {
        if (GetOzobotStorage().command !== 'line_jump') {
            localStorage.setItem('is_ozobot_running', '0');
        }
    }
};

export const GoStraightCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'az') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            if (currentPuzzle.direction === paramsReference.direction) {
                changeColor('blue')
                    .then(() => changeColor('white'))
                    .then(() => changeColor('red'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'));

                SetOzobotStorageCommand('go_forward');
            } else {
                changeColor('red')
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue', 20));
            }
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const GoLeftCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'ba') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            if (currentPuzzle.direction === paramsReference.direction) {
                changeColor('green')
                    .then(() => changeColor('white'))
                    .then(() => changeColor('red'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'));

                SetOzobotStorageCommand('go_left');
            } else {
                changeColor('red')
                    .then(() => changeColor('white'))
                    .then(() => changeColor('green'))
            }
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const GoRightCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bb') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            if (currentPuzzle.direction === paramsReference.direction) {
                changeColor('blue')
                    .then(() => changeColor('red'))
                    .then(() => changeColor('green'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'))
                    .then(() => changeColor('blue'))
                    .then(() => changeColor('white'));

                SetOzobotStorageCommand('go_right');
            } else {
                changeColor('green')
                    .then(() => changeColor('red'))
                    .then(() => changeColor('blue'))
            }
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const TornadoSpin = async (currentPuzzle, paramsReference, rotateRight45, sleep, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bf') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['w', 'e'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['n', 's'].indexOf(currentPuzzle.direction) > -1)
        ) {
            if (currentPuzzle.direction === paramsReference.direction) {    // Spin
                await changeColor('green')
                    .then(() => changeColor('red'))
                    .then(() => changeColor('green'))
                    .then(() => changeColor('red'))
                    .then(() => changeColor('purple'))
                    .then(async () => {
                        for (let i = 0; i < 16; i++) {
                            paramsReference.direction = await rotateRight45(paramsReference.direction);
                            await sleep(200);
                        }
                    })
                    .then(() => changeColor('white'));
            } else {                                                        // Tornado
                await changeColor('red')
                    .then(() => changeColor('green'))
                    .then(() => changeColor('red'))
                    .then(() => changeColor('green'))
                    .then(() => changeColor('blue'))
                    .then(async () => {
                        await sleep(300);
                        for (let i = 1; i <= 16; i++) {
                            paramsReference.direction = await rotateRight45(paramsReference.direction);
                            await sleep(200 / i);
                        }
                    })
                    .then(() => changeColor('white'));
            }
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const LineJumpStraight = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bh') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['s', 'n'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['e', 'w'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('green')
                .then(() => changeColor('blue'))
                .then(() => changeColor('green'));

            SetOzobotStorageCommand('line_jump');
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const LineJumpLeft = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bi') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['s', 'n'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['e', 'w'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('green')
                .then(() => changeColor('red'))
                .then(() => changeColor('green'));

            paramsReference.direction = await rotateLeft(paramsReference.direction);
            SetOzobotStorageCommand('line_jump');
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const LineJumpRight = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bj') {
        if ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['s', 'n'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['e', 'w'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('green'))
                .then(() => changeColor('red'));

            paramsReference.direction = await rotateRight(paramsReference.direction);
            SetOzobotStorageCommand('line_jump');
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const StraightCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (['ac', 'ah', 'am', 'as'].indexOf(currentPuzzle.id) > -1
        && ((['w', 'e'].indexOf(paramsReference.direction) > -1 && ['s', 'n'].indexOf(currentPuzzle.direction) > -1)
            || (['n', 's'].indexOf(paramsReference.direction) > -1 && ['e', 'w'].indexOf(currentPuzzle.direction) > -1))
    ) {
        await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
    }
};

export const ZigzagOrBackWalkCommand = async (currentPuzzle, zigzag, paramsReference, changeColor, rotateLeft, rotateRight, rotateToDirection) => {
    if (currentPuzzle.id === 'bk') {
        if ((['w'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('blue', 200)
                .then(() => changeColor('white'))
                .then(() => changeColor('green'))
                .then(() => changeColor('red'))
                .then(() => changeColor('green'))
                .then(() => zigzag(paramsReference.speed));
        } else if ((['w'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('green'))
                .then(() => changeColor('white'))
                .then(() => changeColor('blue'));

            const direction = await rotateLeft(paramsReference.direction).then(direction => rotateLeft(direction));
            changeColor('red')
                .then(() => zigzag(paramsReference.speed, true))
                .then(() => rotateToDirection(direction, paramsReference.direction));
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const StartStopStoperCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight, sleep) => {
    if (currentPuzzle.id === 'bl') {
        if ((['w'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
        ) {
            const tick = () => sleep(1000)
                    .then(() => changeColor('red'))
                    .then(() => changeColor('white'));

            const startStoper = async () => {
                localStorage.setItem('ozobot_stoper_start', '1');
                let stopped = false;
                for (let i = 1; i <= 30; i++) {
                    if (localStorage.getItem('is_ozobot_running') === '0') {
                        await changeColor(null);
                        return;
                    }
                    if (localStorage.getItem('ozobot_stoper_start') === '0') stopped = true;
                    else await tick();
                }

                if (!stopped) {
                    for (let i = 0; i < 10; i++) {
                        await changeColor('red', 50)
                            .then(() => changeColor('white', 50));
                    }
                    localStorage.setItem('is_ozobot_running', '0');
                }
                localStorage.setItem('ozobot_stoper_start', '0');
            };

            changeColor('red')
                .then(() => changeColor('white'))
                .then(() => changeColor('blue'))
                .then(() => changeColor('green'))
                .then(() => startStoper());
        } else if ((['w'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('green')
                .then(() => changeColor('blue'))
                .then(() => changeColor('white'))
                .then(() => changeColor('red'))
                .then(() => localStorage.setItem('ozobot_stoper_start', '0'));

        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const CountIntersectionsCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bo') {
        if ((['w'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('green')
                .then(() => changeColor('red'))
                .then(() => changeColor('blue'))
                .then(() => changeColor('green'));

            localStorage.setItem('counter_command', 'intersections');
            localStorage.setItem('counter', '0');
        } else if ((['n'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
            || (['w'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('green')
                .then(() => changeColor('blue'))
                .then(() => changeColor('red'))
                .then(() => changeColor('green'));
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const CountTurnsCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'bp') {
        if ((['w'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('blue'))
                .then(() => changeColor('green'))
                .then(() => changeColor('blue'));

            localStorage.setItem('counter_command', 'turns');
            localStorage.setItem('counter', '0');
        } else if ((['n'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
            || (['w'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('blue')
                .then(() => changeColor('green'))
                .then(() => changeColor('blue'))
                .then(() => changeColor('red'));
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const CountColorPathsCommand = async (currentPuzzle, paramsReference, changeColor, rotateLeft, rotateRight) => {
    if (currentPuzzle.id === 'br') {
        if ((['w'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['n'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('green'))
                .then(() => changeColor('blue'))
                .then(() => changeColor('red'));

            localStorage.setItem('counter_command', 'color_paths');
            localStorage.setItem('counter', '0');
        } else if ((['n'].indexOf(paramsReference.direction) > -1 && ['w'].indexOf(currentPuzzle.direction) > -1)
            || (['s'].indexOf(paramsReference.direction) > -1 && ['e'].indexOf(currentPuzzle.direction) > -1)
            || (['w'].indexOf(paramsReference.direction) > -1 && ['s'].indexOf(currentPuzzle.direction) > -1)
            || (['e'].indexOf(paramsReference.direction) > -1 && ['n'].indexOf(currentPuzzle.direction) > -1)
        ) {
            changeColor('red')
                .then(() => changeColor('blue'))
                .then(() => changeColor('green'))
                .then(() => changeColor('red'));
        } else {
            await rotateRandom(paramsReference, changeColor, rotateLeft, rotateRight);
        }
    }
};

export const ClearStorage = () => localStorage.setItem('ozobot_storage', JSON.stringify(ozobotStorage));

const ozobotStorage = {
    command: null
};

export const SetOzobotStorageCommand = command => {
    const storageJSON = localStorage.getItem('ozobot_storage');
    const storage = storageJSON !== null ? JSON.parse(storageJSON) : ozobotStorage;
    storage.command = command;
    localStorage.setItem('ozobot_storage', JSON.stringify(storage));
};

export const GetOzobotStorage = () => {
    const json = localStorage.getItem('ozobot_storage');
    return json !== null ? JSON.parse(json) : ozobotStorage;
};

const rotateByCommand = async (command, paramsReference, forward, rotateLeft, rotateRight, moveMargin, sleep, changeColor, rotateLeft45, rotateRight45) => {
    switch (command) {
        case 'go_left':
            if (rotateLeft !== null) {
                await addTurn(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
                paramsReference.direction = await rotateLeft(paramsReference.direction);
            }  else {
                paramsReference.direction = forward(paramsReference.direction);
            }
            break;
        case 'go_right':
            if (rotateRight !== null){
                await addTurn(moveMargin, sleep, changeColor, paramsReference, rotateLeft45, rotateRight45);
                paramsReference.direction = await rotateRight(paramsReference.direction);
            } else {
                paramsReference.direction = forward(paramsReference.direction);
            }
            break;
        case 'go_forward':
            if (forward !== null) paramsReference.direction = forward(paramsReference.direction);
            break;
        default:
            break;
    }

    SetOzobotStorageCommand(null);
};



// WEBPACK FOOTER //
// ./src/Simulator/Ozobot/OzobotCommands.js